// extracted by mini-css-extract-plugin
module.exports = {"container":"Ta-z","copy":"Ua-z","field":"Va-z","error":"Wa-z","disabled":"Xa-z","termsContainer":"Ya-z","termsHeading":"Za-z","termsCopy":"_a-z","submit":"ab-z","srOnly":"bb-z"};